export class FilterClientProviderViewShipmentDto {
	public searchText: string = null;
	public inBounds: boolean = false;
	public outBounds: boolean = false;
	public lastMonth: boolean = false;
}